import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useData } from '../../contexts/DataContext';
import { useLocation, useNavigate } from 'react-router-dom';
import TaskSelector from './TaskSelector';
import TimeSchedule from './TimeSchedule';
import WeeklyTaskSelector from './WeeklyTaskSelector';
import WeeklyTimeSchedule from './WeeklyTimeSchedule';
import WeeklySummary from './WeeklySummary';
import { 
  Calendar, 
  Clock, 
  CheckSquare, 
  ArrowRight,
  ArrowLeft,
  Building2,
  User,
  FileText,
  X,
  Save,
  MessageSquare,
  AlertCircle,
  Plus,
   Sun,        // הוסף
  RefreshCw   // הוסף
} from 'lucide-react';

const DailyPlanner = ({ 
  onClose, 
  initialPlanningType = 'daily', 
  editPlanData = null, 
  selectedDate: propSelectedDate = null, 
  selectedWeek: propSelectedWeek = null,
  isAddingToExisting: propIsAdding = false,
  currentWeek: propCurrentWeek = null
}) => {  const { currentUser } = useAuth();
  const { projects = [], users = [] } = useData();
  const location = useLocation();
  const navigate = useNavigate();
  
  
  const [currentStep, setCurrentStep] = useState('task-selection');
  const [selectedTasks, setSelectedTasks] = useState([]);
  const [selectedTab, setSelectedTab] = useState('management');
  const [schedule, setSchedule] = useState({});
  const [daySummary, setDaySummary] = useState(null);
  const [planningType, setPlanningType] = useState(initialPlanningType);
  const [isEditing, setIsEditing] = useState(false);
  const [editingPlan, setEditingPlan] = useState(null);
  const [showSummaryOption, setShowSummaryOption] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);
  const [isAddingToExisting, setIsAddingToExisting] = useState(propIsAdding || false);
  
  const [existingScheduledTasks, setExistingScheduledTasks] = useState([]);
  const [dayNotes, setDayNotes] = useState('');
  const [weekNotes, setWeekNotes] = useState('');
  
  // State למעקב אחרי משימות שנגררו
  const [draggedTaskIds, setDraggedTaskIds] = useState([]);
  
  // Weekly planning states
  const [weeklySchedule, setWeeklySchedule] = useState({});
  const [currentWeek, setCurrentWeek] = useState(propCurrentWeek || new Date());
  const [weeklyDraggedTaskIds, setWeeklyDraggedTaskIds] = useState({});

  // useEffect נפרד להגדרת isEditing כש-editPlanData משתנה
  useEffect(() => {
    console.log('=== Checking if should set isEditing ===');
    console.log('editPlanData:', editPlanData);
    
    if (editPlanData) {
      const shouldEdit = editPlanData.mode === 'edit' || editPlanData.isEditMode === true;
      console.log('shouldEdit:', shouldEdit);
      console.log('editPlanData.mode:', editPlanData.mode);
      console.log('editPlanData.isEditMode:', editPlanData.isEditMode);
      
      if (shouldEdit && !isEditing) {
        console.log('>>> Setting isEditing to TRUE');
        setIsEditing(true);
      }
    } else {
      console.log('>>> No editPlanData, isEditing should be false');
      if (isEditing) {
        setIsEditing(false);
      }
    }
  }, [editPlanData]); // רק תלוי ב-editPlanData!

  // טעינה אוטומטית של תכנון קיים כשמשנים תאריך
useEffect(() => {
  console.log('=== Auto-load useEffect ===');
  console.log('isEditing:', isEditing);
  console.log('editPlanData:', editPlanData);
  console.log('planningType:', planningType);
  console.log('selectedDate:', selectedDate);
  
  // אל תטען תכנון אוטומטית אם אנחנו במצב עריכה
  if (isEditing || editPlanData) {
    console.log('>>> SKIPPING auto-load (edit mode)');
    return;
  }
  
  if (planningType === 'daily' && selectedDate && !editPlanData && !isEditing) {
    console.log('>>> Checking for existing plan...');
    const dailyPlans = JSON.parse(localStorage.getItem('dailyPlans') || '[]');
    const existingPlan = dailyPlans.find(plan => 
      plan.date === selectedDate && 
      (plan.userId === currentUser?.id || 
       plan.userId === currentUser?.uid ||
       plan.userName === currentUser?.name)
    );
    
    if (existingPlan) {
      // טען את התכנון הקיים בשקט
      if (existingPlan.selectedTasks) {
        setSelectedTasks(existingPlan.selectedTasks);
      }
      if (existingPlan.schedule) {
        setSchedule(existingPlan.schedule);
        
        // עדכן את המשימות שנגררו
        const draggedIds = [];
        Object.values(existingPlan.schedule).forEach(slot => {
          if (slot?.task?.id) {
            draggedIds.push(slot.task.id);
          }
        });
        setDraggedTaskIds(draggedIds);
      }
      if (existingPlan.dayNotes) {
        setDayNotes(existingPlan.dayNotes);
      }
    }
  }
}, [selectedDate, planningType, isEditing, editPlanData]); // הוסף את התלויות האלה!
  // תיקון: פונקציה לבדיקת תכנון קיים לשבוע
  const checkExistingWeeklyPlan = (weekDate) => {
    const weekStart = getWeekStartDate(weekDate);
    const weekStartStr = weekStart.toISOString().split('T')[0];
    
    const weeklyPlans = JSON.parse(localStorage.getItem('weeklyPlans') || '[]');
    const currentUserPlans = weeklyPlans.filter(plan => 
      plan.userId === currentUser?.id || plan.userName === currentUser?.name
    );
    
    return currentUserPlans.find(plan => 
      plan.summaryData?.weekStart === weekStartStr
    );
  };

  // טעינת הערות שבועיות מ-localStorage
useEffect(() => {
  if (planningType === 'weekly') {
    const savedNotes = localStorage.getItem('currentWeeklyNotes');
    if (savedNotes) {
      try {
        const notesData = JSON.parse(savedNotes);
        if (notesData.notes !== weekNotes) {  // הוסף את הבדיקה הזאת
          setWeekNotes(notesData.notes || '');
        }
      } catch (error) {
        console.error('Error loading weekly notes:', error);
      }
    }
  }
}, [planningType]); // השאר את התלות כמו שהיא
  // עדכון ערכים מה-props
useEffect(() => {
  if (propIsAdding && !isAddingToExisting) {  // הוסף בדיקה
    setIsAddingToExisting(true);
    setPlanningType('weekly');
  }
  
  if (propCurrentWeek) {
    const weekStr = propCurrentWeek.toISOString?.().split('T')[0] || propCurrentWeek;
    const currentStr = currentWeek.toISOString().split('T')[0];
    if (weekStr !== currentStr) {  // הוסף בדיקה
      setCurrentWeek(new Date(propCurrentWeek));
    }
  }
}, [propIsAdding, propCurrentWeek]);

  useEffect(() => {
    console.log('=== DailyPlanner useEffect running ===');
    console.log('editPlanData:', editPlanData);
    console.log('isEditing:', isEditing);
    console.log('editPlanData.mode:', editPlanData?.mode);
    console.log('editPlanData.isEditMode:', editPlanData?.isEditMode);
    
    if (propSelectedDate) {
      setSelectedDate(propSelectedDate);
    } else if (location.state?.selectedDate) {
      setSelectedDate(location.state.selectedDate);
    }
    
    if (propSelectedWeek) {
      setCurrentWeek(new Date(propSelectedWeek));
    }
    
    if (editPlanData) {
      setIsAddingToExisting(editPlanData.mode === 'add_tasks');
      
      // תיקון: בדיקה אם זה מצב של הוספת משימות
      if (editPlanData.mode === 'add_tasks' || editPlanData.isAddingToExisting) {
        setIsAddingToExisting(true);
        setEditingPlan(editPlanData);
        setPlanningType('weekly');
        
        // הגדר את השבוע הנכון
        if (editPlanData.summaryData?.weekStart) {
          setCurrentWeek(new Date(editPlanData.summaryData.weekStart));
        }
        
        // טען את הלוח הקיים
        if (editPlanData.summaryData?.schedule) {
          setWeeklySchedule(editPlanData.summaryData.schedule);
          
          // אסוף את כל המשימות שכבר תוכננו
          const scheduledIds = [];
          const draggedByDay = {};
          
          Object.keys(editPlanData.summaryData.schedule).forEach(dateStr => {
            const daySchedule = editPlanData.summaryData.schedule[dateStr];
            const dayIds = [];
            
            if (daySchedule && typeof daySchedule === 'object') {
              Object.values(daySchedule).forEach(task => {
                if (task && task.id) {
                  scheduledIds.push(task.id);
                  dayIds.push(task.id);
                }
              });
            }
            
            // מצא את האינדקס הנכון של היום
            const date = new Date(dateStr);
            const dayOfWeek = date.getDay();
            const dayIndex = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
            draggedByDay[`day_${dayIndex}`] = dayIds;
          });
          
          setExistingScheduledTasks(scheduledIds);
          setWeeklyDraggedTaskIds(draggedByDay);
        }
        
        // התחל משלב בחירת המשימות
        setCurrentStep('task-selection');
        
      } else {
        // מצב עריכה רגיל
        setIsEditing(true);
        setEditingPlan(editPlanData);
        
        // טעינת התאריך לתכנון יומי
        if (editPlanData.date) {
          setSelectedDate(editPlanData.date);
        }
        
        // טעינת הערות מהתכנון הקיים
        if (editPlanData.dayNotes) {
          setDayNotes(editPlanData.dayNotes);
        }
        if (editPlanData.weekNotes) {
          setWeekNotes(editPlanData.weekNotes);
        }
        
        // וודא שזה מזהה נכון אם זה תכנון יומי או שבועי
        if (editPlanData.planningType) {
          setPlanningType(editPlanData.planningType);
        } else if (editPlanData.summaryData?.weekStart) {
          setPlanningType('weekly');
        } else {
          setPlanningType('daily');
        }
        
        setCurrentStep('task-selection'); // התחל בשלב 1 - בחירת משימות
        
        // טעינת ה-schedule לפי סוג התכנון
        if (editPlanData.planningType === 'weekly' || editPlanData.summaryData?.weekStart) {
          // תכנון שבועי
          if (editPlanData.schedule) {
            setWeeklySchedule(editPlanData.schedule);
            const draggedByDay = {};
            Object.keys(editPlanData.schedule).forEach(dateStr => {
              const daySchedule = editPlanData.schedule[dateStr];
              const draggedIds = [];
              Object.values(daySchedule).forEach(timeSlotTasks => {
                if (Array.isArray(timeSlotTasks)) {
                  timeSlotTasks.forEach(task => {
                    if (task.id) draggedIds.push(task.id);
                  });
                }
              });
              draggedByDay[dateStr] = draggedIds;
            });
            setWeeklyDraggedTaskIds(draggedByDay);
          }
        } else {
          // תכנון יומי
          if (editPlanData.schedule) {
            setSchedule(editPlanData.schedule);
            const draggedIds = [];
            Object.values(editPlanData.schedule).forEach(timeSlot => {
              if (timeSlot.tasks) {
                timeSlot.tasks.forEach(task => {
                  if (task.id) draggedIds.push(task.id);
                });
              } else if (timeSlot.task) {
                // פורמט אחר של schedule
                if (timeSlot.task.id) draggedIds.push(timeSlot.task.id);
              }
            });
            setDraggedTaskIds(draggedIds);
          }
        }
        
        if (editPlanData.selectedTasks) {
          setSelectedTasks(editPlanData.selectedTasks);
        }
      }
    }
  }, [editPlanData]); // הסר את כל השאר!
  // useEffect נפרד לטיפול ב-props
  useEffect(() => {
    if (propSelectedDate && propSelectedDate !== selectedDate) {
      setSelectedDate(propSelectedDate);
    }
  }, [propSelectedDate]);

  useEffect(() => {
    if (propSelectedWeek) {
      const newWeek = new Date(propSelectedWeek);
      if (newWeek.getTime() !== currentWeek.getTime()) {
        setCurrentWeek(newWeek);
      }
    }
  }, [propSelectedWeek]);

  useEffect(() => {
    if (location.state?.selectedDate && location.state.selectedDate !== selectedDate) {
      setSelectedDate(location.state.selectedDate);
    }
  }, [location.state?.selectedDate]);

  // תיקון: בדיקה לפני מעבר לתכנון שבועי
  const handlePlanningTypeChange = (newType) => {
    console.log('=== handlePlanningTypeChange ===');
    console.log('newType:', newType);
    console.log('isEditing:', isEditing);
    console.log('editPlanData:', editPlanData);
    
    // אם זה מצב עריכה, אל תציג חלון - פשוט שנה את הסוג
    if (isEditing || editPlanData) {
      console.log('>>> Edit mode - changing type without prompt');
      setPlanningType(newType);
      return;
    }
    
    if (newType === 'weekly') {
      const existingPlan = checkExistingWeeklyPlan(currentWeek);
      console.log('Existing weekly plan:', existingPlan);
      if (existingPlan && !isAddingToExisting) {
        if (window.confirm('כבר קיים תכנון לשבוע זה. האם תרצה להוסיף משימות לתכנון הקיים?')) {
          setEditingPlan(existingPlan);
          setIsAddingToExisting(true);
          setPlanningType('weekly');
          
          // טען את התכנון הקיים
          if (existingPlan.summaryData?.schedule) {
            setWeeklySchedule(existingPlan.summaryData.schedule);
          }
        }
        return;
      }
    }
    
    setPlanningType(newType);
    setCurrentStep('task-selection');
    if (newType === 'daily') {
      setDraggedTaskIds([]);
    } else {
      setWeeklyDraggedTaskIds({});
    }
  };

  // פונקציות לעדכון משימות שנגררו (יומי)
  const handleTaskDragged = (taskId, timeSlot) => {
    if (taskId && !draggedTaskIds.includes(taskId)) {
      setDraggedTaskIds(prev => [...prev, taskId]);
    }
  };

  const handleTaskRemoved = (taskId) => {
    setDraggedTaskIds(prev => prev.filter(id => id !== taskId));
  };

  // פונקציות לעדכון משימות שנגררו (שבועי)
  const handleWeeklyTaskDragged = (taskId, dayIndex, timeSlot) => {
    const dayKey = `day_${dayIndex}`;
    setWeeklyDraggedTaskIds(prev => ({
      ...prev,
      [dayKey]: [...(prev[dayKey] || []), taskId].filter((id, index, self) => self.indexOf(id) === index)
    }));
  };

  const handleWeeklyTaskRemoved = (taskId, dayIndex) => {
    const dayKey = `day_${dayIndex}`;
    setWeeklyDraggedTaskIds(prev => ({
      ...prev,
      [dayKey]: (prev[dayKey] || []).filter(id => id !== taskId)
    }));
  };

  // חישוב כל המשימות שנגררו בשבוע
  const getAllWeeklyDraggedTaskIds = () => {
    const allIds = [];
    Object.values(weeklyDraggedTaskIds).forEach(dayIds => {
      allIds.push(...dayIds);
    });
    return [...new Set(allIds)];
  };

  // שלבים בתהליך
  const steps = [
    { id: 'task-selection', title: 'בחירת משימות', icon: CheckSquare },
    { id: 'time-schedule', title: 'תכנון זמנים', icon: Clock },
    { id: 'summary', title: 'סיכום', icon: FileText }
  ];

  const currentStepIndex = steps.findIndex(step => step.id === currentStep);

  const handleTasksSelected = (tasks, tab, notes = '') => {
    setSelectedTasks(tasks);
    setSelectedTab(tab);
    if (planningType === 'daily') {
      setDayNotes(notes);
    }
    setCurrentStep('time-schedule');
  };

  const handleScheduleChange = (newSchedule) => {
    setSchedule(newSchedule);
    
    const draggedIds = [];
    Object.values(newSchedule).forEach(timeSlot => {
      if (timeSlot && timeSlot.task && timeSlot.task.id) {
        draggedIds.push(timeSlot.task.id);
      }
    });
    setDraggedTaskIds(draggedIds);
    
    setCurrentStep('summary');
  };

  const handleWeeklyScheduleChange = (newSchedule) => {
    setWeeklySchedule(newSchedule);
    
    const draggedByDay = {};
    
    if (newSchedule && typeof newSchedule === 'object') {
      Object.keys(newSchedule).forEach(day => {
        draggedByDay[day] = [];
        
        const daySchedule = newSchedule[day];
        
        if (daySchedule && typeof daySchedule === 'object') {
          Object.values(daySchedule).forEach(timeSlot => {
            if (!timeSlot) return;
            
            if (timeSlot.tasks && Array.isArray(timeSlot.tasks)) {
              timeSlot.tasks.forEach(task => {
                if (task && task.id) {
                  draggedByDay[day].push(task.id);
                }
              });
            }
            else if (timeSlot.id || timeSlot.taskId) {
              draggedByDay[day].push(timeSlot.id || timeSlot.taskId);
            }
          });
        }
      });
    }
    
    setWeeklyDraggedTaskIds(draggedByDay);
  };
const handleSaveDailyPlan = () => {
  try {
    const dailyPlans = JSON.parse(localStorage.getItem('dailyPlans') || '[]');
    
    // במצב עריכה, שמור את ה-ID הקיים
    const planData = {
      id: (isEditing && editingPlan?.id) ? editingPlan.id : Date.now().toString(),
      date: selectedDate,
      schedule: schedule,
      selectedTasks: selectedTasks,
      dayNotes: dayNotes,
      userId: currentUser?.id || currentUser?.uid,
      userName: currentUser?.name,
      userRole: currentUser?.role,
      departmentId: currentUser?.departmentId,
      departmentName: currentUser?.departmentName,
      teamId: currentUser?.teamId,
      teamName: currentUser?.teamName,
      savedAt: new Date().toISOString(),
      type: 'daily-plan',
      category: 'plan',
      summaryData: {
        date: selectedDate,
        totalTasks: selectedTasks.length,
        scheduledSlots: Object.keys(schedule).length,
        dayNotes: dayNotes
      }
    };
    
    // תיקון: בדיקה משופרת עם userId ו-uid
    const existingIndex = dailyPlans.findIndex(plan => 
      plan.date === planData.date && 
      (plan.userId === currentUser?.id || 
       plan.userId === currentUser?.uid ||
       plan.userName === currentUser?.name)
    );
    
    if (existingIndex >= 0) {
      // במצב עריכה, אל תשאל אישור
      if (!isEditing && !window.confirm('כבר קיים תכנון לתאריך זה. האם להחליף אותו?')) {
        return;
      }
      dailyPlans[existingIndex] = planData;
    } else {
      dailyPlans.push(planData);
    }
    
localStorage.setItem('dailyPlans', JSON.stringify(dailyPlans));
    
    // סנכרון דו-כיווני
    syncDailyToWeeklyPlan(planData);
    
    alert(isEditing ? '✅ התכנון היומי עודכן בהצלחה!' : '✅ התכנון היומי נשמר בהצלחה!');
    onClose();
    
  } catch (error) {
    console.error('Error saving daily plan:', error);
    alert('❌ שגיאה בשמירת התכנון. נסה שוב.');
  }
};

// פונקציה חדשה לסנכרון
const syncDailyToWeeklyPlan = (dailyPlan) => {
  try {
    const weeklyPlans = JSON.parse(localStorage.getItem('weeklyPlans') || '[]');
    const planDate = new Date(dailyPlan.date);
    
    // מצא את תחילת השבוע
    const weekStart = new Date(planDate);
    const day = weekStart.getDay();
    weekStart.setDate(weekStart.getDate() - day);
    const weekStartStr = weekStart.toISOString().split('T')[0];
    
    // מצא או צור תכנון שבועי
    let weeklyPlan = weeklyPlans.find(p => 
      (p.userId === currentUser?.id || p.userName === currentUser?.name) &&
      p.summaryData?.weekStart === weekStartStr
    );
    
    if (!weeklyPlan) {
      // צור תכנון שבועי חדש
      weeklyPlan = {
        id: Date.now().toString(),
        userId: currentUser?.id,
        userName: currentUser?.name,
        savedAt: new Date().toISOString(),
        type: 'weekly_planning',
        summaryData: {
          weekStart: weekStartStr,
          schedule: {}
        }
      };
      weeklyPlans.push(weeklyPlan);
    }
    
    // הוסף/עדכן את המשימות היומיות בתכנון השבועי
    if (!weeklyPlan.summaryData.schedule) {
      weeklyPlan.summaryData.schedule = {};
    }
    
    weeklyPlan.summaryData.schedule[dailyPlan.date] = {};
    
    Object.entries(dailyPlan.schedule).forEach(([time, slot]) => {
      if (slot?.task) {
        weeklyPlan.summaryData.schedule[dailyPlan.date][time] = {
          ...slot.task,
          duration: slot.duration || 1,
          fromDailyPlan: true
        };
      }
    });
    
    // שמור
    localStorage.setItem('weeklyPlans', JSON.stringify(weeklyPlans));
    console.log('✅ סונכרן עם תכנון שבועי');
    
  } catch (error) {
    console.error('Error syncing to weekly plan:', error);
  }
};



// פונקציה חדשה - סנכרון מתכנון שבועי ליומי - שורה 475
const syncWeeklyToDailyPlans = (weeklyPlan) => {
  try {
    const dailyPlans = JSON.parse(localStorage.getItem('dailyPlans') || '[]');
    
    Object.entries(weeklyPlan.summaryData?.schedule || {}).forEach(([dateStr, daySchedule]) => {
      let dailyPlanIndex = dailyPlans.findIndex(p => 
        p.date === dateStr && 
        (p.userId === currentUser?.id || 
         p.userId === currentUser?.uid ||
         p.userName === currentUser?.name)
      );
      
      let dailyPlan;
      if (dailyPlanIndex >= 0) {
        dailyPlan = dailyPlans[dailyPlanIndex];
      } else {
        dailyPlan = {
          id: Date.now().toString() + Math.random(),
          date: dateStr,
          userId: currentUser?.id || currentUser?.uid,
          userName: currentUser?.name,
          schedule: {},
          selectedTasks: [],
          savedAt: new Date().toISOString(),
          type: 'daily-plan',
          fromWeeklySync: true
        };
        dailyPlans.push(dailyPlan);
      }
      
      // מיזוג משימות מהשבועי ליומי
      Object.entries(daySchedule || {}).forEach(([time, task]) => {
        if (task && !task.fromDailyPlan) {
          dailyPlan.schedule[time] = {
            task: task,
            duration: task.duration || 1
          };
        }
      });
    });
    
    localStorage.setItem('dailyPlans', JSON.stringify(dailyPlans));
    console.log('✅ סונכרן לתכנונים יומיים');
    
  } catch (error) {
    console.error('Error syncing to daily plans:', error);
  }
};



  // תיקון: פונקציה משופרת לשמירת תכנון שבועי
const handleSaveSummary = (summaryData) => {
  setDaySummary(summaryData);
  
  if (summaryData.schedule) {
    const weeklyPlans = JSON.parse(localStorage.getItem('weeklyPlans') || '[]');
    const weekStartStr = getWeekStartDate(currentWeek).toISOString().split('T')[0];
    
    const existingPlanIndex = weeklyPlans.findIndex(plan => 
      (plan.userId === currentUser?.id || plan.userName === currentUser?.name) &&
      plan.summaryData?.weekStart === weekStartStr
    );
    
    // מצב הוספת משימות - רק עדכן, אל תיצור חדש!
    if (isAddingToExisting && existingPlanIndex >= 0) {
      const existingPlan = weeklyPlans[existingPlanIndex];
      const existingSchedule = existingPlan.summaryData.schedule || {};
      const mergedSchedule = { ...existingSchedule };
      
      Object.keys(summaryData.schedule).forEach(dateStr => {
        if (!mergedSchedule[dateStr]) {
          mergedSchedule[dateStr] = {};
        }
        Object.keys(summaryData.schedule[dateStr]).forEach(time => {
          if (!mergedSchedule[dateStr][time]) {
            mergedSchedule[dateStr][time] = summaryData.schedule[dateStr][time];
          }
        });
      });
      
      weeklyPlans[existingPlanIndex].summaryData.schedule = mergedSchedule;
      weeklyPlans[existingPlanIndex].savedAt = new Date().toISOString();
      
localStorage.setItem('weeklyPlans', JSON.stringify(weeklyPlans));

// סנכרון חדש - מתכנון שבועי ליומי
const savedPlan = weeklyPlans[existingPlanIndex];
if (savedPlan) {
  syncWeeklyToDailyPlans(savedPlan);
}

alert('✅ המשימות נוספו לתכנון השבועי בהצלחה!');
onClose();
      onClose();
      return; // ← קריטי! יוצאים מהפונקציה כאן
    }
    
    // עדכון תכנון קיים (לא במצב הוספה)
    if (existingPlanIndex >= 0 && !isAddingToExisting) {
      weeklyPlans[existingPlanIndex] = {
        userId: currentUser?.id,
        userName: currentUser?.name,
        weekNotes: weekNotes,
        savedAt: new Date().toISOString(),
        summaryData: {
          ...summaryData,
          weekStart: weekStartStr,
          weekNotes: weekNotes
        },
        type: 'weekly_planning'
      };
      
      alert('✅ התכנון השבועי עודכן בהצלחה!');
      
    // יצירת תכנון חדש (רק אם לא במצב הוספה)
    } else if (existingPlanIndex === -1 && !isAddingToExisting) {
      const planData = {
        userId: currentUser?.id,
        userName: currentUser?.name,
        weekNotes: weekNotes,
        savedAt: new Date().toISOString(),
        summaryData: {
          ...summaryData,
          weekStart: weekStartStr,
          weekNotes: weekNotes
        },
        type: 'weekly_planning'
      };
      weeklyPlans.push(planData);
      
      alert('✅ התכנון השבועי נוצר בהצלחה!');
    }
    
    // שמירה אחת ויחידה ל-localStorage
    localStorage.setItem('weeklyPlans', JSON.stringify(weeklyPlans));
  }
  
  onClose();
};

  const handleGoBack = () => {
    switch (currentStep) {
      case 'time-schedule':
        setCurrentStep('task-selection');
        break;
      case 'summary':
        setCurrentStep('time-schedule');
        break;
      default:
        break;
    }
  };

const getWeekDates = (date) => {
  const startOfWeek = new Date(date);
  const day = startOfWeek.getDay();
  
  // אם זה יום ראשון, תישאר
  // אחרת חזור ליום ראשון
  if (day !== 0) {
    startOfWeek.setDate(startOfWeek.getDate() - day);
  }
  
  const weekDates = [];
  for (let i = 0; i < 7; i++) {
    const date = new Date(startOfWeek);
    date.setDate(startOfWeek.getDate() + i);
    weekDates.push(date);
  }
  return weekDates;
};

const getWeekStartDate = (date) => {
  const startOfWeek = new Date(date);
  const day = startOfWeek.getDay();
  
  // אם זה יום ראשון (0), תישאר באותו יום
  // אחרת, חזור למספר הימים הנדרשים
  if (day !== 0) {
    startOfWeek.setDate(startOfWeek.getDate() - day);
  }
  
  return startOfWeek;
};
  const mergeTasks = (existingTasks, newTasks) => {
  const merged = [...existingTasks];
  
  newTasks.forEach(newDay => {
    const existingDayIndex = merged.findIndex(day => day.date === newDay.date);
    
    if (existingDayIndex !== -1) {
      // אם היום כבר קיים, הוסף את המשימות החדשות
      const existingDay = merged[existingDayIndex];
      const existingTaskIds = new Set(existingDay.tasks.map(t => t.id));
      
      newDay.tasks.forEach(newTask => {
        if (!existingTaskIds.has(newTask.id)) {
          existingDay.tasks.push(newTask);
        }
      });
    } else {
      // אם היום לא קיים, הוסף אותו
      merged.push(newDay);
    }
  });
  
  return merged;
};

  const weekDates = getWeekDates(currentWeek);
  const dayNames = ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת'];

  const getProjectName = (projectId) => {
    const project = projects.find(p => p.id === projectId);
    return project ? project.name : 'ללא פרויקט';
  };

  const handleTaskClick = (taskId) => {
    navigate(`/tasks`, { state: { taskId } });
  };

  const tasksWithProjects = selectedTasks.map(task => ({
    ...task,
    projectName: getProjectName(task.projectId)
  }));

  // Handle backdrop clicks only
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  // Prevent all keyboard events from closing the modal
  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      e.preventDefault();
      onClose();
    }
  };

  return (
    <>
      {/* Backdrop - רקע כהה עם סגירה בלחיצה */}
      <div 
        className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4 overflow-y-auto"
        onClick={handleBackdropClick}
        onKeyDown={handleKeyDown}
        tabIndex={-1}
      >
        {/* Modal Container - הטופס עצמו */}
        <div 
          className="bg-white rounded-3xl shadow-2xl w-full max-w-7xl my-8 max-h-[95vh] overflow-y-auto flex flex-col animate-slideUp"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <div className="bg-white/80 backdrop-blur-xl rounded-3xl shadow-2xl border border-white/20 w-full min-h-full">
          {/* Header with Steps */}
          <div className="p-8 border-b border-gray-100/50 bg-gradient-to-r from-blue-50/50 to-purple-50/50">
            <div className="flex items-center justify-between mb-6">
              <div>
                <h1 className="text-3xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
                  {isAddingToExisting 
                    ? 'הוספת משימות לתכנון שבועי קיים'
                    : planningType === 'daily' 
                    ? 'תכנון יום עבודה' 
                    : 'תכנון שבוע עבודה'}
                </h1>
                <p className="text-gray-600 mt-2 text-lg">
                  {isAddingToExisting 
                    ? `הוספת משימות לתכנון השבוע של ${currentWeek.toLocaleDateString('he-IL')}`
                    : `שלום ${currentUser?.name}, בואו נארגן את ${planningType === 'daily' ? 'היום' : 'השבוע'} שלך בצורה מושלמת ✨`}
                </p>
              </div>
              <button
                onClick={onClose}
                className="p-3 hover:bg-gray-100/80 rounded-2xl transition-all duration-200 hover:scale-105"
              >
                <span className="text-gray-500 text-xl">✕</span>
              </button>
            </div>

            {/* תיקון: הצגת התראה על תכנון קיים */}
            {isAddingToExisting && (
              <div className="mb-6 p-4 bg-yellow-50 rounded-xl border border-yellow-200">
                <div className="flex items-center gap-2">
                  <AlertCircle className="w-5 h-5 text-yellow-600" />
                  <span className="font-medium text-yellow-800">
                    אתה מוסיף משימות לתכנון קיים. השעות התפוסות יוצגו באפור.
                  </span>
                </div>
              </div>
            )}

            {/* Planning Type Tabs - תיקון: הסתרה במצב הוספת משימות */}
            {!isAddingToExisting && (
              <div className="flex justify-center mb-6">
                <div className="bg-white/90 backdrop-blur-xl rounded-3xl shadow-2xl border border-white/20 p-2">
                  <div className="flex space-x-2 bg-gray-100/80 p-2 rounded-2xl backdrop-blur-sm">
                    <button
                      onClick={() => handlePlanningTypeChange('daily')}
                      className={`px-6 py-3 rounded-xl text-sm font-semibold transition-all duration-300 flex items-center justify-center gap-3 ${
                        planningType === 'daily'
                          ? 'bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow-lg scale-105'
                          : 'text-gray-600 hover:text-gray-900 hover:bg-white/50'
                      }`}
                    >
                      <Calendar className="w-5 h-5" />
                      תכנן את היום שלך
                    </button>
                    <button
                      onClick={() => handlePlanningTypeChange('weekly')}
                      className={`px-6 py-3 rounded-xl text-sm font-semibold transition-all duration-300 flex items-center justify-center gap-3 ${
                        planningType === 'weekly'
                          ? 'bg-gradient-to-r from-green-500 to-green-600 text-white shadow-lg scale-105'
                          : 'text-gray-600 hover:text-gray-900 hover:bg-white/50'
                      }`}
                    >
                      <Calendar className="w-5 h-5" />
                      תכנן את השבוע שלך
                    </button>
                  </div>
                </div>
              </div>
            )}

    {/* Date Selection */}
<div className="flex justify-center mb-6">
  <div className="bg-white/90 backdrop-blur-xl rounded-3xl shadow-2xl border border-white/20 p-6">
    <div className="flex flex-col items-center space-y-4">
      <div className="flex items-center space-x-4">
        <Calendar className="w-6 h-6 text-blue-500" />
        <label className="text-sm font-medium text-gray-700">
          {planningType === 'daily' ? 'בחר יום לתכנון:' : 'בחר שבוע לתכנון:'}
        </label>
      </div>
      
{/* כפתורים מהירים - רק לתכנון יומי */}
{planningType === 'daily' && (
  <div className="flex gap-3 mb-3">
   <button
  type="button"
  onClick={(e) => {
    e.preventDefault();
    e.stopPropagation();
    const today = new Date().toISOString().split('T')[0];
    setSelectedDate(today);
  }}
      className={`px-5 py-3 rounded-xl font-medium transition-all flex items-center gap-2 ${
        selectedDate === new Date().toISOString().split('T')[0]
          ? 'bg-gradient-to-r from-blue-600 to-blue-700 text-white shadow-lg'
          : 'bg-blue-100 text-blue-700 hover:bg-blue-200'
      }`}
    >
      <Calendar className="w-4 h-4" />
      תכנן את היום
    </button>
    
    <button
      type="button"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        const tomorrowStr = tomorrow.toISOString().split('T')[0];
        setSelectedDate(tomorrowStr);
      }}
      className={`px-5 py-3 rounded-xl font-medium transition-all flex items-center gap-2 ${
        (() => {
          const tomorrow = new Date();
          tomorrow.setDate(tomorrow.getDate() + 1);
          return selectedDate === tomorrow.toISOString().split('T')[0];
        })()
          ? 'bg-gradient-to-r from-green-600 to-green-700 text-white shadow-lg'
          : 'bg-green-100 text-green-700 hover:bg-green-200'
      }`}
    >
      <Sun className="w-4 h-4" />
      תכנן את מחר
    </button>
    
    {/* כפתור תכנן מחדש - מופיע רק אם יש תכנון קיים */}
    {(() => {
      const dailyPlans = JSON.parse(localStorage.getItem('dailyPlans') || '[]');
      const hasExistingPlan = dailyPlans.some(plan => 
        plan.date === selectedDate && 
        (plan.userId === currentUser?.id || plan.userName === currentUser?.name)
      );
      
      if (hasExistingPlan) {
        return (
          <button
            type="button"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              
              if (window.confirm(
                '⚠️ פעולה זו תמחק את התכנון הקיים!\n\n' +
                'האם אתה בטוח שברצונך למחוק ולתכנן מחדש?'
              )) {
                // מחיקת התכנון
                const updatedPlans = dailyPlans.filter(plan => 
                  !(plan.date === selectedDate && 
                    (plan.userId === currentUser?.id || plan.userName === currentUser?.name))
                );
                localStorage.setItem('dailyPlans', JSON.stringify(updatedPlans));
                
                // איפוס למצב התחלתי
                setCurrentStep('task-selection');
                setSelectedTasks([]);
                setSchedule({});
                setEditingPlan(null);  // תוקן!
                setIsEditing(false);   // תוקן!
                
                alert('✅ התכנון נמחק! אתה יכול להתחיל מחדש');
              }
            }}
            className="px-5 py-3 bg-red-100 text-red-700 hover:bg-red-200 rounded-xl font-medium transition-all flex items-center gap-2"
          >
            <RefreshCw className="w-4 h-4" />
            תכנן מחדש
          </button>
        );
      }
      return null;
    })()}
  </div>
)}
{/* כפתורים מהירים - תכנון שבועי */}
{planningType === 'weekly' && (
  <div className="flex gap-3 mb-3">
    <button
      type="button"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        const today = new Date();
        const currentWeekStart = getWeekStartDate(today);
        
        // בדיקה אם יש תכנון קיים לשבוע הנוכחי
        const existingPlan = checkExistingWeeklyPlan(currentWeekStart);
        
        // אל תציג הודעה במצב עריכה
        if (existingPlan && !isAddingToExisting && !isEditing) {
          const result = window.confirm(
            '📅 כבר קיים תכנון לשבוע הנוכחי.\n\n' +
            'לחץ "אישור" - להוסיף משימות לתכנון הקיים\n' +
            'לחץ "ביטול" - לבטל'
          );
          
          if (result) {
            setEditingPlan(existingPlan);
            setIsAddingToExisting(true);
            
            if (existingPlan.summaryData?.schedule) {
              setWeeklySchedule(existingPlan.summaryData.schedule);
            }
          }
        } else {
          setCurrentWeek(currentWeekStart);
        }
      }}
      className={`px-5 py-3 rounded-xl font-medium transition-all flex items-center gap-2 ${
        getWeekStartDate(currentWeek).toISOString().split('T')[0] === 
        getWeekStartDate(new Date()).toISOString().split('T')[0]
          ? 'bg-gradient-to-r from-blue-600 to-blue-700 text-white shadow-lg'
          : 'bg-blue-100 text-blue-700 hover:bg-blue-200'
      }`}
    >
      <Calendar className="w-4 h-4" />
      השבוע הנוכחי
    </button>
    
    <button
      type="button"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        const nextWeek = new Date();
        nextWeek.setDate(nextWeek.getDate() + 7);
        const nextWeekStart = getWeekStartDate(nextWeek);
        
        // בדיקה אם יש תכנון קיים לשבוע הבא
        const existingPlan = checkExistingWeeklyPlan(nextWeekStart);
        
        // אל תציג הודעה במצב עריכה
        if (existingPlan && !isAddingToExisting && !isEditing) {
          const result = window.confirm(
            '📅 כבר קיים תכנון לשבוע הבא.\n\n' +
            'לחץ "אישור" - להוסיף משימות לתכנון הקיים\n' +
            'לחץ "ביטול" - לבטל'
          );
          
          if (result) {
            setEditingPlan(existingPlan);
            setIsAddingToExisting(true);
            
            if (existingPlan.summaryData?.schedule) {
              setWeeklySchedule(existingPlan.summaryData.schedule);
            }
          }
        } else {
          setCurrentWeek(nextWeekStart);
        }
      }}
      className={`px-5 py-3 rounded-xl font-medium transition-all flex items-center gap-2 ${
        getWeekStartDate(currentWeek).toISOString().split('T')[0] === 
        getWeekStartDate((() => {
          const next = new Date();
          next.setDate(next.getDate() + 7);
          return next;
        })()).toISOString().split('T')[0]
          ? 'bg-gradient-to-r from-green-600 to-green-700 text-white shadow-lg'
          : 'bg-green-100 text-green-700 hover:bg-green-200'
      }`}
    >
      <Sun className="w-4 h-4" />
      השבוע הבא
    </button>
  </div>
)}
      
      {/* בחירת תאריך ידנית */}
      <input
        type="date"
        value={planningType === 'daily' ? selectedDate : currentWeek.toISOString().split('T')[0]}
        onChange={(e) => {
          if (planningType === 'daily') {
            setSelectedDate(e.target.value);
          } else {
            setCurrentWeek(new Date(e.target.value));
          }
        }}
        className="px-4 py-2 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        min={new Date().toISOString().split('T')[0]}
      />
      {/* הצגת השבוע שנבחר */}
      {planningType === 'weekly' && (
        <div className="mt-3 text-center">
          <p className="text-sm text-gray-600">
            תכנון לשבוע: {weekDates[0].toLocaleDateString('he-IL')} - {weekDates[6].toLocaleDateString('he-IL')}
          </p>
        </div>
      )}
      
     
    </div>
  </div>
</div>

            {/* Progress Steps */}
            <div className="flex items-center justify-center space-x-8">
              {steps.map((step, index) => {
                const Icon = step.icon;
                const isActive = step.id === currentStep;
                const isCompleted = index < currentStepIndex;
                
                return (
                  <div key={step.id} className="flex items-center">
                    <div className={`flex items-center gap-3 px-6 py-4 rounded-2xl transition-all duration-300 ${
                      isActive ? 'bg-gradient-to-r from-blue-500 to-purple-500 text-white shadow-lg scale-105' : 
                      isCompleted ? 'bg-gradient-to-r from-green-400 to-emerald-500 text-white shadow-md' : 
                      'bg-gray-100/80 text-gray-500 hover:bg-gray-200/80'
                    }`}>
                      <div className={`p-2 rounded-xl ${
                        isActive ? 'bg-white/20' : 
                        isCompleted ? 'bg-white/20' : 
                        'bg-gray-200'
                      }`}>
                        <Icon className="w-5 h-5" />
                      </div>
                      <span className="font-semibold">{step.title}</span>
                    </div>
                    {index < steps.length - 1 && (
                      <div className={`w-12 h-1 mx-4 rounded-full transition-all duration-300 ${
                        index < currentStepIndex ? 'bg-gradient-to-r from-green-400 to-emerald-500' : 'bg-gray-200'
                      }`} />
                    )}
                  </div>
                );
              })}
            </div>
          </div>

          {/* Content */}
          <div className="overflow-y-auto flex-1">
            {planningType === 'daily' ? (
              <>
                {currentStep === 'task-selection' && (
                  <TaskSelector
                    onTasksSelected={handleTasksSelected}
                    onClose={onClose}
                    draggedTaskIds={draggedTaskIds}
                    selectedDate={selectedDate}
                    isEditing={isEditing}
                    initialTasks={selectedTasks}
                  />
                )}

                {currentStep === 'time-schedule' && (
                  <TimeSchedule
                    selectedTasks={tasksWithProjects}
                    onScheduleChange={handleScheduleChange}
                    onClose={onClose}
                    onTaskDragged={handleTaskDragged}
                    onTaskRemoved={handleTaskRemoved}
                    draggedTaskIds={draggedTaskIds}
                    initialSchedule={isEditing ? schedule : null}
                    selectedDate={selectedDate}
                  />
                )}

                {currentStep === 'summary' && (
                  <div className="bg-white/90 backdrop-blur-xl rounded-3xl shadow-2xl border border-white/20 max-w-5xl mx-auto">
                    {/* Header */}
                    <div className="p-8 border-b border-gray-100/50 bg-gradient-to-r from-green-50/50 to-blue-50/50">
                      <div className="flex items-center justify-between">
                        <div>
                          <h2 className="text-2xl font-bold bg-gradient-to-r from-green-600 to-blue-600 bg-clip-text text-transparent">
                            תכנון היום מוכן! 🎉
                          </h2>
                          <p className="text-gray-600 mt-2 text-lg">
                            התכנון שלך מוכן לשמירה. בדוק שהכל נראה טוב ולחץ על "שמור תכנון יום".
                          </p>
                        </div>
                        <button
                          onClick={onClose}
                          className="p-3 hover:bg-gray-100/80 rounded-2xl transition-all duration-200 hover:scale-105"
                        >
                          <X className="w-5 h-5 text-gray-500" />
                        </button>
                      </div>
                    </div>

                    <div className="p-8">
                      {/* סיכום התכנון */}
                      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
                        <div className="bg-gradient-to-br from-blue-50 to-blue-100 p-6 rounded-2xl border border-blue-200/50">
                          <h3 className="text-lg font-semibold text-blue-800 mb-2">משימות שנבחרו</h3>
                          <div className="text-3xl font-bold text-blue-900">{selectedTasks.length}</div>
                          <p className="text-sm text-blue-600 mt-1">משימות לתכנון</p>
                        </div>
                        
                        <div className="bg-gradient-to-br from-green-50 to-green-100 p-6 rounded-2xl border border-green-200/50">
                          <h3 className="text-lg font-semibold text-green-800 mb-2">שעות מתוכננות</h3>
                          <div className="text-3xl font-bold text-green-900">{Object.keys(schedule).length}</div>
                          <p className="text-sm text-green-600 mt-1">חלונות זמן</p>
                        </div>
                        
                        <div className="bg-gradient-to-br from-purple-50 to-purple-100 p-6 rounded-2xl border border-purple-200/50">
                          <h3 className="text-lg font-semibold text-purple-800 mb-2">סה"כ שעות</h3>
                          <div className="text-3xl font-bold text-purple-900">
                            {Object.values(schedule).reduce((sum, item) => sum + (item.duration || 1), 0).toFixed(1)}
                          </div>
                          <p className="text-sm text-purple-600 mt-1">שעות עבודה</p>
                        </div>
                      </div>

                      {/* רשימת המשימות המתוכננות */}
                      <div className="mb-8">
                        <h3 className="text-lg font-semibold text-gray-800 mb-4">המשימות שתוכננו:</h3>
                        <div className="bg-gray-50 rounded-2xl p-4 max-h-60 overflow-y-auto">
                          {Object.entries(schedule).map(([time, item]) => (
                            <div key={time} className="flex items-center justify-between py-2 border-b border-gray-200 last:border-0">
                              <div className="flex items-center gap-3">
                                <span className="font-mono text-sm font-bold text-gray-600">{time}</span>
                                <span className="text-gray-800">{item.task?.title || 'משימה'}</span>
                              </div>
                              <span className="text-sm text-gray-500">{item.duration || 1} שעות</span>
                            </div>
                          ))}
                        </div>
                      </div>

                      {/* שדה הערות ומטרות */}
                      <div className="mb-8">
                        <div className="flex items-center gap-2 mb-3">
                          <MessageSquare className="w-5 h-5 text-blue-600" />
                          <h3 className="text-lg font-semibold text-gray-800">הערות ומטרות ליום</h3>
                          <span className="text-sm text-gray-500">(אופציונלי)</span>
                        </div>
                        <textarea
                          value={dayNotes}
                          onChange={(e) => setDayNotes(e.target.value)}
                          placeholder="רשום מטרות, הערות ותזכורות חשובות ליום המתוכנן...
לדוגמה:
- להתכונן לישיבה עם הלקוח בשעה 14:00
- לסיים את הדוח החודשי
- מטרה: להשלים את כל המשימות הדחופות"
                          className="w-full h-32 px-4 py-3 border-2 border-gray-300 rounded-xl resize-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white"
                        />
                        <div className="text-sm text-gray-500 mt-2">
                          💡 ההערות ישמרו יחד עם התכנון ותוכל לראות אותן בלוח הבקרה
                        </div>
                      </div>

                      {/* כפתורי פעולה */}
                      <div className="flex gap-4 justify-center">
                        <button
                          onClick={handleSaveDailyPlan}
                          className="px-8 py-4 bg-gradient-to-r from-green-600 to-emerald-600 text-white rounded-2xl hover:from-green-700 hover:to-emerald-700 transition-all duration-300 font-bold text-lg shadow-lg hover:shadow-xl transform hover:scale-105 flex items-center gap-3"
                        >
                          <Save className="w-6 h-6" />
                          שמור תכנון יום
                        </button>
                        
                        <button
                          onClick={() => setCurrentStep('time-schedule')}
                          className="px-8 py-4 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-2xl hover:from-blue-600 hover:to-purple-700 transition-all duration-300 font-bold text-lg shadow-lg hover:shadow-xl hover:scale-105"
                        >
                          ✏️ ערוך תכנון
                        </button>
                        
                        <button
                          onClick={onClose}
                          className="px-8 py-4 bg-gray-500 text-white rounded-2xl hover:bg-gray-600 transition-all duration-300 font-bold text-lg"
                        >
                          ביטול
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </>
            ) : (
              <>
                {currentStep === 'task-selection' && (
                  <WeeklyTaskSelector
                    selectedTasks={selectedTasks}
                    setSelectedTasks={setSelectedTasks}
                    selectedTaskType={selectedTab}
                    setSelectedTaskType={setSelectedTab}
                    onNext={() => setCurrentStep('time-schedule')}
                    weekDates={weekDates}
                    dayNames={dayNames}
                    draggedTaskIds={getAllWeeklyDraggedTaskIds()}
                    existingScheduledTasks={existingScheduledTasks}
                  />
                )}

                {currentStep === 'time-schedule' && (
                  <WeeklyTimeSchedule
                    selectedTasks={selectedTasks}
                    weeklySchedule={weeklySchedule}
                    setWeeklySchedule={handleWeeklyScheduleChange}
                    onNext={() => setCurrentStep('summary')}
                    onPrevious={() => setCurrentStep('task-selection')}
                    weekDates={weekDates}
                    dayNames={dayNames}
                    onTaskDragged={handleWeeklyTaskDragged}
                    onTaskRemoved={handleWeeklyTaskRemoved}
                    draggedTaskIds={weeklyDraggedTaskIds}
                    onTaskClick={handleTaskClick}
                  />
                )}

                {currentStep === 'summary' && (
                  <WeeklySummary
                    selectedTasks={selectedTasks}
                    weeklySchedule={weeklySchedule}
                    onSave={handleSaveSummary}
                    onPrevious={() => setCurrentStep('time-schedule')}
                    weekDates={weekDates}
                    dayNames={dayNames}
                  />
                )}
              </>
            )}
          </div>

          {/* Navigation Footer */}
          {currentStep !== 'task-selection' && planningType === 'daily' && currentStep !== 'summary' && (
            <div className="p-4 border-t bg-gray-50">
              <div className="flex items-center justify-between">
                <button
                  onClick={handleGoBack}
                  className="flex items-center gap-2 px-4 py-2 text-gray-600 hover:text-gray-800 transition-colors"
                >
                  <ArrowLeft className="w-4 h-4" />
                  חזור
                </button>
                
                <div className="text-sm text-gray-600">
                  שלב {currentStepIndex + 1} מתוך {steps.length}
                </div>
              </div>
            </div>
          )}

          {/* Navigation Footer */}
          {currentStep !== 'task-selection' && planningType === 'daily' && currentStep !== 'summary' && (
            <div className="p-4 border-t bg-gray-50">
              <div className="flex items-center justify-between">
                <button
                  onClick={handleGoBack}
                  className="flex items-center gap-2 px-4 py-2 text-gray-600 hover:text-gray-800 transition-colors"
                >
                  <ArrowLeft className="w-4 h-4" />
                  חזור
                </button>
                
                <div className="text-sm text-gray-600">
                  שלב {currentStepIndex + 1} מתוך {steps.length}
                </div>
              </div>
            </div>
          )}
          </div>
        </div>
      </div>
    </>
  );
};

export default DailyPlanner;